import { FC } from 'react';
import Drawer from '../Drawer';
import { Question } from './Question';

export type FaqDrawerProps = {
  question: string;
  answer: React.ReactNode;
  isOpen?: boolean;
  onClick?: () => void;
  hasDarkBackground?: boolean;
};

export const FaqDrawer: FC<FaqDrawerProps> = ({ question, answer, isOpen, hasDarkBackground, onClick }) =>
  <Drawer
    open={isOpen}
    renderTrigger={() => (
      <Question question={question} onClick={onClick} hasDarkBackground={hasDarkBackground} isOpen={isOpen} />
    )}
  >
    <div className="px-2 md:px-3 pb-4">{answer}</div>
  </Drawer>
